import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import MusicAnalyzer from './components/MusicAnalyzer';
import SettingsModal from './components/SettingsModal';
import './App.css';

function App() {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  return (
    <Router>
      <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden font-sans">
        <Header onSettingsClick={() => setIsSettingsOpen(true)} />
        <main className="flex-1 flex flex-col items-center py-8 px-4 md:px-8 lg:px-16 w-full max-w-[1400px] mx-auto gap-8">
          <Routes>
            <Route path="/" element={<MusicAnalyzer />} />
          </Routes>
        </main>
        
        <SettingsModal 
          isOpen={isSettingsOpen} 
          onClose={() => setIsSettingsOpen(false)} 
        />
      </div>
    </Router>
  );
}

export default App;